import { Injectable } from '@angular/core';
import {
    Router,
    CanActivate,
    CanActivateChild,
    RouterStateSnapshot,
    ActivatedRouteSnapshot,
} from '@angular/router';

import { AuthService } from './auth.service';
import { JwtHelper } from './auth.jwt';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
    constructor(private authService: AuthService, private router: Router) {}

    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let rval: boolean = false;
        try {
            if (this.authService.isAuth() && !JwtHelper.isTokenExpired(this.authService.getToken()))
                rval = true;
        } catch (e) {
            console.log('Error verifying token:' + e);

            rval = false;
        }

        if (rval == false) {
            this.authService.saveTargetUrl(state.url);

            this.router.navigateByUrl('/login');
        }

        return rval;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    getCookie(name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length == 2) {
            return parts.pop().split(';').shift();
        }
        return null;
    }
}
